"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
/** @jsxFrag React.Fragment */
const b_1 = __importDefault(require("b_"));
const modal_1 = require("src/context/modal");
const question_1 = require("src/utils/question");
const question_2 = __importDefault(require("../question"));
const question_scale_1 = __importDefault(require("../question-scale"));
const question_table_scale_styles_1 = __importDefault(require("./question-table-scale.styles"));
const b = b_1.default.with('question-table-scale');
function TableScale(props) {
    const { id, minValue, maxValue, type, noOpinionAnswer, boundQuestions, boundQuestionsRevision, handleClickOption, handleClickNoOpinionAnswer, visible, rows, errorVisible } = props, rest = __rest(props, ["id", "minValue", "maxValue", "type", "noOpinionAnswer", "boundQuestions", "boundQuestionsRevision", "handleClickOption", "handleClickNoOpinionAnswer", "visible", "rows", "errorVisible"]);
    const { showImageModal, displayHiddenQuestions } = (0, modal_1.useModalContext)();
    const isAtLeastOneRowVisible = (0, question_1.isAtLeastOneTableRowVisible)(boundQuestionsRevision);
    if (!displayHiddenQuestions && !isAtLeastOneRowVisible) {
        return null;
    }
    const isQuestionHidden = displayHiddenQuestions && !isAtLeastOneRowVisible;
    const isQuestionVisible = isQuestionHidden ? false : visible;
    const handleClick = (ev, optionId, questionId) => {
        handleClickOption(optionId, questionId, 
        // @ts-ignore
        Number(ev.target.parentElement.closest('div[data-value]').dataset.value));
    };
    return ((0, jsx_runtime_1.jsx)(question_2.default, Object.assign({}, rest, { type: type, id: id, visible: isQuestionVisible, errorVisible: errorVisible }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: question_table_scale_styles_1.default, className: b() }, { children: [(0, jsx_runtime_1.jsx)(ColumnOrderingLabels, { minValue: minValue, maxValue: maxValue, noOpinionAnswer: noOpinionAnswer, isHidden: isQuestionHidden }), boundQuestions.map((questionId, i) => {
                    const currentQuestionRevision = boundQuestionsRevision[questionId];
                    if (!currentQuestionRevision.visible && !displayHiddenQuestions) {
                        return null;
                    }
                    const isHidden = currentQuestionRevision.visible === false && displayHiddenQuestions;
                    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('row', {
                            isHidden,
                            allRowsHidden: !isAtLeastOneRowVisible,
                            hasError: errorVisible
                        }) }, { children: (0, jsx_runtime_1.jsx)(question_scale_1.default, { isTableBoundQuestion: true, multipleChoice: false, questionIndex: id, boundQuestionId: questionId, handleClickOption: evt => handleClick(evt, id, questionId), options: currentQuestionRevision.options, rowData: rows[i], noOpinionAnswer: currentQuestionRevision.noOpinionAnswer, handleClickNoOpinionAnswer: handleClickNoOpinionAnswer, openModal: showImageModal, isHidden: isHidden }) }), questionId));
                })] })) })));
}
exports.default = TableScale;
function ColumnOrderingLabels({ minValue, maxValue, noOpinionAnswer, isHidden }) {
    const { isDemo } = (0, modal_1.useModalContext)();
    const divs = [];
    for (let i = minValue; i <= maxValue; i += 1) {
        divs.push((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('option-label') }, { children: i }), i));
    }
    if (noOpinionAnswer.enabled) {
        divs.push((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('no-option-label') }, { children: noOpinionAnswer.label || '' }), noOpinionAnswer.label));
    }
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('columns-header-wrapper', { isDemo, isHidden }) }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('columns-header') }, { children: divs })) })));
}
